import { useState } from 'react';
import './App.css';
import { WindowContextProvider } from './components/WindowContextProvider';
import { Bootstrap } from './components/Bootstrap';
import { Header } from './components/Header';

const App = (): React.JSX.Element => {
  const [hh,setHH] = useState<number>(0);
  const [scale,setScale] = useState<number>(1);

  return (
    <WindowContextProvider>
      <div className="App">
        <Header setHH={setHH} setScale={setScale}/>
        <Bootstrap hh={hh} scale={scale} />
      </div>
    </WindowContextProvider>
  );
}

export default App;
